import ExpeditionChapterHeading from "./ExpeditionChapterHeading";
import IconLink from "./IconLink";
import { siteUrl } from "./site";
import "./ExpeditionDetail.css";
import "./NierDetail.css";
import { highlightCode } from "./codeHighlight";

const moonLinks = {
  source: "https://github.com/SoExDobin/Moonlighter-Portfolio",
  youtube: "https://www.youtube.com/watch?v=h-GAey4My9A&list=PLB_KDWv0W5Qo&index=2",
};
// Code links are pinned to the public portfolio repository commit.
const sourceAt = (path: string) => `${moonLinks.source}/blob/614e0b80c31a7066b93f8b6295f44b605ab0fd1b/${path}`;
const img = (name: string) => siteUrl(`/images/moonlighter/${name}.jpg`);

// 코드 발췌는 develop 브랜치(40e6c13) 기준이다. 생략한 줄은 // ... 로 표시한다.
const frameLoop = `// Client/Code/CMainApp.cpp: 한 프레임의 순서
_int CMainApp::Update_MainApp(const _float fDeltaTime)
{
    Engine::CDInputManager::GetInstance()->Update_InputDev();
    m_pManageClass->Update_Scene(fDeltaTime);                   // Scene → Layer → GameObject → Component
    Engine::CCollisionManager::GetInstance()->Update_Collision();
    return 0;
}

void CMainApp::LateUpdate_MainApp(const _float fDeltaTime)
{
    m_pManageClass->LateUpdate_Scene(fDeltaTime);
    CFadeManager::GetInstance()->Check_FadeEnd_Event();
}

void CMainApp::Render_MainApp()
{
    // ...
    m_pManageClass->Render_Scene(m_pGraphicDevice);            // 렌더 그룹 → PendingEvent
    // ...
}

// Engine/Code/CScene.cpp: Layer 번호 순서대로 갱신
_int CScene::Update_Scene(const _float fTimeDelta)
{
    for (_uint16 i = LAYER0; i != LAYER_NONE; i = i << 1)
        m_umLayer[i]->Update_Layer(fTimeDelta);
    return 0;
}

// Engine/Code/CLayer.cpp: Destroy 표시가 붙은 오브젝트는 여기서 빠지고 해제
for (auto iterObj = pair.second.begin(); iterObj != pair.second.end(); )
{
    iResult = (*iterObj)->Update_GameObject(fTimeDelta);       // Destroy 표시면 0이 아닌 값
    if (iResult)
    {
        CGameObject* pObj = *iterObj;
        iterObj = pair.second.erase(iterObj);
        Safe_Release(pObj);
        continue;
    }
    ++iterObj;
}

// Engine/Code/CGameObject.cpp: 붙어 있는 Component를 차례로 갱신
_int CGameObject::Update_GameObject(const _float fTimeDelta)
{
    for (size_t i = 0; i < ID_END; ++i)
        for (auto iter = m_umComponent[i].begin(); iter != m_umComponent[i].end(); )
        {
            if (m_bIsDestroy)
                iter->second->Set_Destroy();                    // Component에도 삭제 표시
            iResult = iter->second->Update_Component(fTimeDelta);
            // ...
        }
    return m_bIsDestroy;
}

// Engine/Code/CRenderer.cpp: Update 중에 등록된 렌더 그룹을 순서대로 그림
void CRenderer::Add_RenderGroup(RENDERID eID, CGameObject* pGameObject)
{
    // ...
    if (pGameObject->Is_Destroy()) return;                     // 삭제 예정이면 그리지 않음
    m_RenderGroup[eID].push_back(pGameObject);
    pGameObject->AddRef();
}

void CRenderer::Render_GameObject(LPDIRECT3DDEVICE9& pGraphicDev)
{
    Render_Priority(pGraphicDev);
    Render_NonAlpha(pGraphicDev);
    Render_Alpha(pGraphicDev);                                  // 카메라에서 먼 것부터 정렬
    Render_UI(pGraphicDev);
    Clear_RenderGroup();
}`;

const collisionLoop = `// Engine/Code/TagLayerMask.cpp
void TagLayerMask::Add_Mask(const wstring& wsLayerTag)
{
    LAYERID eID = CLayerHelper::GetInstance()->GetLayerIDByName(wsLayerTag);   // Layer 이름 → Layer 비트
    if ((iMask & eID) == 0)
        iMask += eID;
}
// Sub_Mask는 같은 방식으로 비트를 끄고, Ease_Mask는 iMask를 0으로 비움

// Client/Code/CBossWallFront.cpp: 벽은 Player와 Monster만 검사
this->Get_LayerMask().Ease_Mask();
this->Get_LayerMask().Add_Mask(CDataManager::GetInstance()->Get_LayerTag(PLAYER_LAYER));
this->Get_LayerMask().Add_Mask(CDataManager::GetInstance()->Get_LayerTag(MONSTER_LAYER));

// Engine/Code/CCollisionManager.cpp
void CCollisionManager::Update_Collision()
{
    for (_uint i = 0; i < iColSize; ++i)
    {
        CCollider* pSrc = m_vecCollider[i];
        if (pSrc == nullptr || pSrc->Get_Owner() == nullptr) continue;
        if (pSrc->Is_Destroy()) continue;                               // 삭제 예정 이면 넘김
        if (pSrc->Is_Enable() == false) continue;                       // 활성 상태 확인

        for (_uint j = i + 1; j < iColSize; ++j)
        {
            // ... pDst도 같은 검사

            // Dst가 충돌 대상이면
            if ((tSrcMask.iMask & tDstMask.eLayerID) != 0)
            {
                bSrcCol = pSrc->Check_Collision(pDst);              // Mask를 통과한 쌍만 도형 판정

                if (bSrcCol)
                {
                    if (pSrc->Is_Overlapped(pDst)) // 이전 충돌 맴버
                        pSrc->Set_Collision({ pDstOwner, pDst, STAY_COL });
                    else                           // 첫 충돌 맴버
                    {
                        pSrc->Add_OverlapMember(pDst);
                        pSrc->Set_Collision({ pDstOwner, pDst, ENTER_COL });
                    }
                }
                else
                {
                    // ...
                    if (pSrc->Is_Overlapped(pDst))
                    {
                        pSrc->Set_Collision({ pDstOwner, pDst , EXIT_COL });
                        pSrc->Release_OverlapMember(pDst);
                        bSrcCol = true;
                    }
                }
            }

            // Src가 충돌 대상이면: pDst 쪽도 같은 순서로 판정
            // ...

            // 양쪽 판정이 끝난 뒤 콜백
            if (bSrcCol) pSrcOwner->On_Collision(pSrc->Get_Collision());
            if (bDstCol) pDstOwner->On_Collision(pDst->Get_Collision());
        }
    }
}`;

const sceneTiming = `// Engine/Code/CManagement.cpp
void CManagement::Render_Scene(LPDIRECT3DDEVICE9 pGraphicDev)
{
    CRenderer::GetInstance()->Render_GameObject(pGraphicDev);
    m_pCurScene->Render_Scene();

    // 렌더링이 끝난 뒤 예약된 Scene 교체 · 구조 변경을 한꺼번에 실행
    for_each(m_vecPendingEvent.begin(), m_vecPendingEvent.end(),
        [](function<void()>& e) -> void { if (e) e(); });

    Release_PendingEvent();
}

// Client/Code/CMapManager.cpp: 맵 Trigger에서 던전으로 넘어갈 때
e = [=]() -> void {
    CManagement::GetInstance()->Set_Scene(CDungeonScene::Create(pGraphicDev));
    CFadeManager::GetInstance()->Fade_Out();        // 새 Scene에서 화면을 다시 밝힘
    };
// ...
CFadeManager::GetInstance()->Fade_In(e);            // 화면을 덮고, 다 덮이면 e를 실행

// Client/Code/CFadeManager.cpp
void CFadeManager::Check_FadeEnd_Event()
{
    if (m_pFadeUI->Is_Fading_End())
    {
        if (m_AfterEventlist.empty()) return;

        // Fade가 끝난 프레임에 넘겨받은 함수를 PendingEvent로 넘긴다
        CManagement::GetInstance()->Add_PendingEvent(m_AfterEventlist.front());
        m_AfterEventlist.pop_front();
    }
}`;

const bossTrail = `// Client/Code/CBossDesert.cpp
void CBossDesert::Record_HeadTrail()
{
    // ...
    if (D3DXVec3LengthSq(&vDest) >= m_fRecordStep * m_fRecordStep)
        m_deqHeadTrail.push_front(vPos);                    // 0.35만큼 움직일 때마다 기록

    const _int maxPoints = ((_int)m_vecNode.size() + 1) * PointsPerSegment() + 64;
    while ((_int)m_deqHeadTrail.size() > maxPoints)
        m_deqHeadTrail.pop_back();                          // 몸체가 다 지나간 점은 버림
}

void CBossDesert::Apply_TrainBody(const _float fTimeDelta)
{
    const int pps = PointsPerSegment();                     // 몸체 간격 4 / 기록 간격 0.35
    // ...
    for (size_t i = 0; i < m_vecNode.size(); ++i)
    {
        const int idx = (int)((i + 1) * pps);               // 지금의 목록 순서로 목표 점을 정함
        if (idx >= (int)m_deqHeadTrail.size()) continue;   // 궤적이 아직 부족하면 넘어감

        _vec3 vTarget = m_deqHeadTrail[idx];
        // ...
        _float speed = baseSpeed;
        if (fDist > m_fBodySpacing * 2.f)
            speed *= catchMul;                              // 멀리 떨어지면 2.5배로 따라붙음
        // ...
    }
}

void CBossDesert::LateUpdate_GameObject(const _float fTimeDelta)
{
    // ...
    // 죽은 노드 제거: 뒤 몸체들의 목록 순서가 한 칸씩 당겨짐
    for (auto pNode = m_vecNode.begin(); pNode != m_vecNode.end();)
    {
        if ((*pNode)->Get_IsDead())
        {
            pNode = m_vecNode.erase(pNode);
            continue;
        }
        ++pNode;
    }
}`;

const bossAttack = `// Client/Code/CBossDesert.cpp
void CBossDesert::CheckWall(const _float fTimeDelta)
{
    // ...
    if ((m_pUpChecker->Is_Wall() && m_pLeftChecker->Is_Wall()) ||
        (m_pDownChecker->Is_Wall() && m_pRightChecker->Is_Wall()))
    {
        m_eState = TURN;
        m_pMovement->Turn(D3DXToRadian(90.f));              // 모서리: 90° 회전
        return;
    }
    // ... 반대쪽 모서리는 -90°

    // 나아가는 쪽 하나만 벽이면 90°와 45° 중 무작위
    _int i = Get_Int_Random<_int>(0, 1);
    if (IsLeftWall || IsRightWall || IsUpWall || IsDownWall)
    {
        if (i) m_pMovement->Turn(D3DXToRadian(90.f));
        else m_pMovement->Turn(D3DXToRadian(45.f));
        m_eState = TURN;
    }
}

void CBossDesert::Attack(const _float fTimeDelta)
{
    // ... 쿨타임, 모든 몸체 준비 확인
    size_t i = m_vecNode.size() + n_fAttackCnt - 1;         // n_fAttackCnt = 1
    _int iPattern = Get_Int_Random<_int>(0, (_int)i);

    if (iPattern == 0)
    {
        m_eState = LIGHT;                                   // Body Light
        for (auto pNode : m_vecNode)
            pNode->OnLight_Attack();
        m_pMovement->Set_IsMove(false);                     // 머리는 멈춤
    }
    else
        m_vecNode[iPattern - 1]->OnAttack();               // 몸체별 투사체
}

// Client/Code/CBoss3CircleBody.cpp: Body Light 중 벽에 닿으면 반사
if (m_pWallChecker->Is_Wall() && m_pWallChecker->Get_ColState() == ENTER_COL)
{
    _vec3 vNormal = m_pWallChecker->Get_ColNormal();
    _float fScalar = D3DXVec3Dot(&m_vDir, &vNormal);
    m_vDir = m_vDir - (2.f * fScalar) * vNormal;
    D3DXVec3Normalize(&m_vDir, &m_vDir);
}`;

const colliderRemove = `// Engine/Code/CCollider.cpp
void CCollider::Free()
{
    CCollisionManager::GetInstance()->Remove_Collider(this);
    m_usetOverlapCol.clear();
    CComponent::Free();
}

void CCollider::On_Disable()
{
    // ... 상태 초기화
    m_usetOverlapCol.clear();
    CCollisionManager::GetInstance()->Remove_CheckMember(this);
}

// Engine/Code/CCollisionManager.cpp
void CCollisionManager::Remove_Collider(CCollider* pColComonent)
{
    if (!pColComonent) return;

    Remove_CheckMember(pColComonent);

    auto it = std::remove(m_vecCollider.begin(), m_vecCollider.end(), pColComonent);
    m_vecCollider.erase(it, m_vecCollider.end());
}

void CCollisionManager::Remove_CheckMember(CCollider* pColComonent)
{
    for (auto* p : m_vecCollider)
    {
        if (p && p != pColComonent)
            p->Release_OverlapMember(pColComonent);
    }
}`;

const sphereRect = `// Engine/Code/CCollisionManager.cpp: SphereRectCollision
// 수정 전: 축마다 Rect 양 끝 중 구 중심에 가까운 쪽을 골라, 최근접점이 늘 꼭짓점이 됨
if (fabsf(vSpherePos.x - vRectMin.x) > fabsf(vSpherePos.x - vRectMax.x))
    vClosestPoint.x = vRectMax.x;
else
    vClosestPoint.x = vRectMin.x;
// ... y, z도 같은 방식

// 수정 후(12.03): 범위 밖일 때만 끝값으로 자르고, 범위 안이면 구 중심 좌표를 그대로 사용
if (vSpherePos.x < vRectMin.x)          vClosestPoint.x = vRectMin.x;
else if (vSpherePos.x > vRectMax.x)     vClosestPoint.x = vRectMax.x;
else                                    vClosestPoint.x = vSpherePos.x;
// ... y, z도 같은 방식

vClosestPoint = vClosestPoint - vSpherePos;
_float fDistance = D3DXVec3LengthSq(&vClosestPoint);
_float fRadius = pSrc->Get_Radius() * pSrc->Get_Scale();
return fDistance <= (fRadius * fRadius);    // 최근접점까지 거리와 반지름 비교`;

const cacheRestore = `// Engine/Header/CGameObject.h: 오브젝트를 지우거나 넘기는 정적 함수 두 개
static void Destroy(CGameObject* pObj) { pObj->Set_Destroy(); }  // 파괴할 오브젝트로 변경 다음 업데이트에 제거
static void DontDestroySceneLoad(CGameObject* pObj);             // 해당 오브젝트를 캐시 등록하여 다음씬에 재사용

// Engine/Code/CGameObject.cpp
void CGameObject::DontDestroySceneLoad(CGameObject* pObj)
{
    CManagement::GetInstance()->Add_CacheObject(pObj);
}

// Client/Code/CVillageScene.cpp: 팀원이 쓰는 방식, Layer 이름 · 키를 적고 함수 하나
if (CGameObject* pInvenPlayer = CInvenPlayer::Create(m_pGraphicDevice))
{
    pInvenPlayer->Init_Layer(CDataManager::GetInstance()->Get_LayerTag(UI_LAYER), L"UI_PlayerInven");
    Engine::CGameObject::DontDestroySceneLoad(pInvenPlayer);
}

// Engine/Code/CManagement.cpp: 이전 Scene 해제 → 캐시 오브젝트를 새 Scene으로
HRESULT CManagement::Set_Scene(CScene* pScene)
{
    if (pScene == nullptr) return E_FAIL;
    Safe_Release(m_pCurScene);      // 각 Layer가 오브젝트 참조를 놓음
    m_pCurScene = pScene;
    Load_CacheObject();
    return S_OK;
}

// Engine/Code/CLayer.cpp
void CLayer::Free()
{
    // ...
    for (auto& pObj : pair.second)
        Safe_Release(pObj);         // 참조가 0이 된 오브젝트만 실제로 해제, 캐시가 쥔 오브젝트는 남음
}

// Engine/Code/CScene.cpp
HRESULT CScene::Ready_Scene()
{
    // ...
    CCollisionManager::GetInstance()->Clear_CollisionGroup();       // 기존 충돌 멤버 제거
    // ...
}

// Engine/Code/CManagement.cpp
void CManagement::Load_CacheObject()
{
    for (auto& pObj : m_usetCacheObject)
    {
        CLayer* pTargetLayer = m_pCurScene->Get_Layer(pObj->Get_Object_LayerMask().wsLayerTag);

        pTargetLayer->Add_GameObject(pObj->Get_Object_LayerMask().wsObjectKey, pObj);
        pObj->AddRef();

        vector<CComponent*> refRectColliders;
        pObj->Get_Components(ID_DYNAMIC, RECT_COLLIDER, refRectColliders);
        for (auto rectCol : refRectColliders)
            CCollisionManager::GetInstance()->Add_Collider(static_cast<CCollider*>(rectCol));

        // ... SPHERE_COLLIDER도 같은 방식으로 다시 등록
    }
}

CGameObject* CManagement::Get_Object(const wstring& wsLayerTag, const wstring& wsObjTag)
{
    // ... 현재 Scene의 Layer에서 먼저 찾고
    if (iter == itEnd) {
        for (auto& cache : m_usetCacheObject)
        {
            if (cache->Get_Object_LayerMask().wsObjectKey == wsObjTag
                && cache->Get_Object_LayerMask().wsLayerTag == wsLayerTag)
                return cache;
        }
        return nullptr;
    }
    return iter->second.front();
}`;

function Evidence({ summary, code, children, links }: { summary: string; code: string; children?: string; links: { label: string; href: string }[] }) {
  return <details className="expedition-evidence"><summary>{summary}</summary><pre><code>{highlightCode(code)}</code></pre>{children && <p>{children}</p>}{links.map((link, i) => <span key={link.href}>{i > 0 && " "}<IconLink href={link.href} target="_blank" rel="noopener noreferrer">{link.label} ↗</IconLink></span>)}</details>;
}

function Flow({ label, steps }: { label: string; steps: string[] }) {
  return <div className="expedition-flow" aria-label={label}>{steps.map(step => <div key={step}><strong>{step}</strong></div>)}</div>;
}

function Frame({ name, alt, title, children }: { name: string; alt: string; title: string; children: string }) {
  return <figure className="nier-media">
    <IconLink href={img(name)} target="_blank" rel="noopener noreferrer"><img src={img(name)} alt={alt} width="1128" height="674" loading="lazy" /></IconLink>
    <figcaption><strong>{title}</strong><span>{children}</span></figcaption>
  </figure>;
}

export default function MoonlighterDetail() {
  return <main className="expedition-page nier-detail moonlighter-detail">
    <div className="container expedition-breadcrumbs"><IconLink href={siteUrl("/#projects")}>← 프로젝트 목록</IconLink><span>/</span><span>Moonlighter</span></div>
    <header className="expedition-hero">
      <div className="expedition-hero-banner"><div className="container">
        <p className="expedition-project-type">DirectX 9 · 자체 엔진 · 5인 팀 프로젝트</p>
        <h1>Moonlighter</h1>
        <p className="expedition-hero-lead">팀이 함께 쓰는 엔진 프레임워크를 설계하고,<br />그 위에 사막 던전 보스를 올렸습니다.</p>
        <p className="expedition-intro">《Moonlighter》를 DirectX 9 자체 엔진으로 옮긴 5인 팀 학습용 모작입니다. 저는 Engine DLL의 프레임워크를 맡아 GameObject · Component · Layer 구조와 충돌, Scene 전환을 만들었고, 팀원들은 그 위에서 Player · 몬스터 · UI · 맵을 만들었습니다. 팀원이 기능을 붙일 때마다 Engine을 고치지 않도록 Layer 이름과 게임용 Component는 Client가 등록하게 하고, 오브젝트를 지우거나 다음 Scene으로 넘기는 일은 Engine 함수 두 개로만 하게 했습니다. 후반에는 사막 던전 보스를 직접 만들었습니다.</p>
      </div></div>
      <div className="container expedition-hero-content">
        <dl className="expedition-facts">
          <div><dt>개발 기간</dt><dd>2025.11.14 ~ 12.22</dd></div>
          <div><dt>제작</dt><dd>5인 팀 · 학습 목적 모작</dd></div>
          <div><dt>개발 환경</dt><dd>C++ · DirectX 9 · D3DX9</dd></div>
          <div><dt>라이브러리</dt><dd>DirectInput 8 · FMOD · ImGui</dd></div>
          <div className="expedition-facts-tools"><dt>담당</dt><dd>Engine 프레임워크(GameObject · Component · Layer · 충돌 · Scene 전환) · Client 사막 던전 보스</dd></div>
        </dl>
        <div className="expedition-actions"><IconLink href={moonLinks.source} target="_blank" rel="noopener noreferrer">GitHub ↗</IconLink><IconLink href={moonLinks.youtube} target="_blank" rel="noopener noreferrer">시연 영상 ↗</IconLink></div>
        <div className="expedition-video"><iframe src="https://www.youtube.com/embed/h-GAey4My9A" title="Moonlighter 팀 프로젝트 시연 영상" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen /></div>
      </div>
    </header>
    <nav className="expedition-local-nav" aria-label="Moonlighter 상세 목차"><div className="container"><IconLink href="#overview">개요</IconLink><IconLink href="#work">담당 구현</IconLink><IconLink href="#problems">어려웠던 점</IconLink><IconLink href="#retrospective">회고</IconLink><IconLink href="#closing">관련 자료</IconLink></div></nav>

    <section id="overview" className="expedition-overview" aria-labelledby="moon-overview-title">
      <header className="expedition-group-banner"><div className="container expedition-group-heading expedition-overview-heading"><span className="expedition-kicker">OVERVIEW / ROLE</span><h2 id="moon-overview-title">개요</h2></div></header>
      <div className="container expedition-overview-content">
        <div className="expedition-overview-block">
          <h3>담당 구현</h3>
          <div className="expedition-responsibilities">
            <article><h4><IconLink href="#framework">GameObject · Component · Layer 프레임워크</IconLink></h4><p className="expedition-role-summary">GameObject에 Component를 붙여 오브젝트를 만들고, Layer가 갱신 순서와 삭제를 맡으며, LayerMask 비트로 충돌 대상을 먼저 거릅니다.</p></article>
            <article><h4><IconLink href="#boss">사막 던전 보스 CBossDesert</IconLink></h4><p className="expedition-role-summary">몸체 네 개가 머리의 궤적을 따라가고, 벽을 만나면 방향을 틀며 몸체별 공격을 고릅니다.</p></article>
          </div>
        </div>
        <div className="expedition-overview-block">
          <h3>어려웠던 점</h3>
          <div className="expedition-responsibilities">
            <article><h4><IconLink href="#lifetime">오브젝트 생명주기와 DontDestroy 재사용</IconLink></h4><p className="expedition-role-summary">Client는 Destroy와 DontDestroySceneLoad만 부르고, Engine이 Update에서는 삭제 표시로, Scene 교체 때는 참조 카운트로 지울 것과 남길 것을 가립니다.</p></article>
            <article><h4><IconLink href="#collision">Collider 참조 해제와 Sphere · Rect 판정</IconLink></h4><p className="expedition-role-summary">해제되는 Collider가 Manager와 상대 겹침 목록에서 스스로 빠지게 하고, 탄막(Sphere)이 Player(Rect)를 지나가도 맞지 않던 판정을 최근접점 계산으로 고쳤습니다.</p></article>
          </div>
        </div>
        <div className="expedition-overview-block expedition-overview-system">
          <h3>작업 흐름</h3>
          <div className="expedition-system-content">
            <ol className="expedition-system-flow nier-timeline" aria-label="담당 작업 순서">
              <li><strong>프레임워크 기본 구조</strong><span>2025.11.16 ~ 11.26</span></li>
              <li><strong>LayerMask · 충돌</strong><span>11.22 ~ 12.03</span></li>
              <li><strong>Scene 전환</strong><span>11.28 ~ 12.10</span></li>
              <li><strong>사막 던전 보스</strong><span>12.12 ~ 12.18</span></li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section id="work" className="expedition-group" aria-labelledby="moon-work-title">
      <header className="expedition-group-banner"><div className="container expedition-group-heading"><span className="expedition-kicker">CORE IMPLEMENTATIONS / 01–02</span><h2 id="moon-work-title">담당 구현</h2></div></header>

      <section id="framework" className="expedition-case"><div className="container expedition-case-inner">
        <ExpeditionChapterHeading number="01" label="ENGINE / FRAMEWORK" title="GameObject · Component · Layer 프레임워크" technology="Engine DLL · Prototype Component · Layer · LayerMask · CRenderer" />
        <div className="expedition-case-content expedition-pipeline-copy">
          <p>Engine은 DLL로 따로 빌드됩니다. 게임 기능이 늘 때마다 Engine을 고치면 다섯 명이 같은 DLL을 다시 빌드하고 병합 충돌을 풀어야 해서, Engine에는 Layer 번호와 Component 틀, 생명주기만 두고 게임에 관한 이름과 기능은 Client가 등록하게 나눴습니다.</p>
          <h4 className="nier-subhead">GameObject와 Component</h4>
          <p>GameObject는 Component를 담는 틀이고, 오브젝트가 무엇인지는 붙인 Component로 정해집니다. Transform으로 위치를, Texture로 모습을, Rect · Sphere Collider로 충돌 범위를 갖고, GameObject는 Update와 LateUpdate마다 자기 Component를 차례로 갱신합니다. Engine Component는 enum으로 Prototype을 복제해 붙이고, Client가 만든 Component는 문자열 태그로 Prototype Manager에 등록해 두면 Add_Component에 그 태그를 넘겨 똑같이 붙일 수 있습니다. 그래서 전투 수치나 이동처럼 게임에만 필요한 기능은 클라이언트 개발자가 Engine을 고치지 않고 Client Component로 직접 작성해 적용할 수 있게 했습니다.</p>
          <h4 className="nier-subhead">Layer</h4>
          <p>Engine의 Layer는 LAYER0~15 번호만 있고 이름이 없습니다. Scene은 준비할 때 16개를 모두 만들어 두고, Client가 번호마다 Player · Monster · UI 같은 이름을 붙이면 그 뒤로는 이름으로 찾습니다. 이름과 번호 변환은 CLayerHelper가 맡아서 Engine 코드에는 Client의 Layer 구성이 들어가지 않습니다.</p>
          <p>오브젝트가 Layer에 들어가면 그 Layer의 비트와 이름, 오브젝트 키가 오브젝트의 LayerMask에 적히고, 이 값을 충돌 필터와 Scene 전환 때 캐시 복원이 그대로 씁니다. Scene은 Update · LateUpdate · Render를 Layer 번호 순서로 돌리고, Layer는 Update 중에 Destroy 표시가 붙은 오브젝트를 목록에서 빼고 해제합니다.</p>
          <h4 className="nier-subhead">LayerMask 충돌 필터</h4>
          <p>충돌 대상도 Layer로 거릅니다. GameObject마다 LayerMask가 있고, 여기에 자기 Layer 비트(eLayerID)와 반응할 Layer 비트를 모은 iMask가 들어 있습니다. iMask는 처음에 16개를 모두 켠 0xFFFF이고, Client가 Add_Mask · Sub_Mask에 Layer 이름을 넘기면 CLayerHelper가 이름을 비트로 바꿔 켜고 끕니다. 보스방 벽은 Ease_Mask로 비운 뒤 Player와 Monster만 켜 두어, 다른 벽이나 환경 오브젝트와는 판정하지 않습니다.</p>
          <p>충돌 검사에서는 Collider 쌍마다 두 방향을 따로 거릅니다. A의 iMask에 B의 Layer 비트가 켜져 있을 때만 A 쪽에서 판정해 A의 On_Collision을 부르고, B 쪽은 B의 iMask로 다시 확인합니다. 비트 AND 한 번에서 걸러진 쌍은 Rect · Sphere 거리 계산까지 가지 않고, A는 B에 반응하는데 B는 A를 무시하는 한쪽 관계도 Mask만으로 만들 수 있습니다. 통과한 쌍은 도형 판정 뒤 지난 프레임의 겹침 목록과 비교해 Enter · Stay · Exit를 보내며, 맞았을 때 피해를 받을지 밀려날지는 오브젝트가 이 콜백에서 정합니다.</p>
          <Evidence summary="LayerMask 필터 · 충돌 검사 코드 보기" code={collisionLoop} links={[{ label: "TagLayerMask.cpp 보기", href: sourceAt("Engine/Code/TagLayerMask.cpp") }, { label: "CCollisionManager 코드 보기", href: sourceAt("Engine/Code/CCollisionManager.cpp") }]} />
          <h4 className="nier-subhead">프레임 실행 순서</h4>
          <p>한 프레임은 CMainApp이 입력, Scene Update, 충돌 검사, LateUpdate, Render 순서로 돌립니다. Scene Update는 Layer에서 GameObject, Component로 내려가며 갱신하고, 그 사이 그릴 오브젝트는 스스로 렌더 그룹에 등록합니다. Render에서는 Priority · NonAlpha · Alpha · UI 그룹 순서로 그리고, Alpha 그룹은 카메라에서 먼 것부터 정렬해 그립니다. 삭제 표시가 붙은 오브젝트는 렌더 그룹에 들어가지 않고, 렌더링이 끝나면 예약해 둔 Scene 교체를 실행합니다.</p>
          <Flow label="한 프레임의 실행 순서" steps={["입력", "Scene Update · 삭제 처리", "충돌 검사 · On_Collision", "LateUpdate", "Render · PendingEvent"]} />
          <Evidence summary="프레임 실행 순서 · Update · Render 코드 보기" code={frameLoop} links={[{ label: "CMainApp.cpp 보기", href: sourceAt("Client/Code/CMainApp.cpp") }, { label: "CLayer.cpp 보기", href: sourceAt("Engine/Code/CLayer.cpp") }, { label: "CGameObject.cpp 보기", href: sourceAt("Engine/Code/CGameObject.cpp") }, { label: "CRenderer.cpp 보기", href: sourceAt("Engine/Code/CRenderer.cpp") }]} />
        </div>
      </div></section>

      <section id="boss" className="expedition-case"><div className="container expedition-case-inner">
        <ExpeditionChapterHeading number="02" label="CLIENT / BOSS" title="사막 던전 보스 CBossDesert" technology="deque 이동 궤적 · WallChecker · 그룹 HP · FMOD" />
        <div className="expedition-case-content expedition-pipeline-copy">
          <p>머리와 몸체 네 개가 한 줄로 이어져 방 안을 도는 보스입니다. 머리인 CBossDesert가 몸체 목록을 들고 이동 · 공격 · 체력을 관리합니다.</p>
          <ul className="nier-detail-list">
            <li><strong>deque 궤적 추종:</strong> 머리가 0.35 움직일 때마다 위치를 deque에 넣고, 몸체 i는 (i + 1) × 11번째 점을 따라갑니다. 머리를 바로 쫓지 않아 모서리에서도 머리가 지나간 길을 그대로 밟습니다.</li>
            <li><strong>몸체 파괴 후 재정렬:</strong> 부서진 몸체는 LateUpdate에서 목록에서 빠지고, 남은 몸체는 매 프레임 지금의 목록 순서로 목표 점을 다시 받습니다. 그래서 뒤에 있던 몸체가 한 칸 앞 점을 목표로 삼아 빈자리를 메우고, 간격의 두 배 넘게 벌어지면 2.5배 속도로 따라붙습니다.</li>
            <li><strong>WallChecker 회전:</strong> 머리 앞뒤 · 좌우의 판정 상자로 벽을 찾아 모서리에서는 90°, 앞만 막히면 90°나 45°로 돕니다. 회전을 여러 프레임에 나눠 적용해 궤적이 곡선으로 남습니다.</li>
            <li><strong>공격 선택:</strong> 0부터 남은 몸체 수까지 무작위로 뽑아 0이면 Body Light, 나머지는 그 번호 몸체의 공격입니다. 몸체 공격은 쏘는 방향을 돌려 가며 뿌리는 회전 탄막, 10° 간격 36발을 세 번 쏘는 원형 탄막, 떨어진 자리에 10초 동안 남는 용암 장판, 떨어진 자리에서 Player가 다가오거나 10초가 지나면 터지는 불 몬스터 네 가지입니다.</li>
            <li><strong>Body Light:</strong> 머리가 멈추고 몸체들이 피해 영역을 켠 채 벽 법선으로 진행 방향을 반사하며 튕기다가, 끝나면 빠른 속도로 줄에 돌아옵니다.</li>
            <li><strong>그룹 HP · FMOD:</strong> HP Bar는 머리와 몸체 체력을 합쳐 보여 주고, 몸체가 남아 있는 동안 머리는 무적입니다. 이동 · 투사체 · 사망 소리는 FMOD로 냅니다.</li>
          </ul>
          <div className="nier-media-pair nier-media-pair-three">
            <Frame name="boss-trail" alt="머리 뒤로 몸체 네 개가 한 줄로 이어져 움직이는 사막 보스" title="머리 궤적 추종">몸체 네 개가 머리가 지나간 길을 따라 한 줄로 움직입니다(시연 영상 11:07).</Frame>
            <Frame name="boss-light" alt="줄에서 떨어진 몸체들이 주황색 테두리를 켠 채 흩어져 있는 장면" title="Body Light">머리가 멈춘 동안 몸체들이 피해 영역을 켜고 벽에 튕기며 움직입니다(10:51).</Frame>
            <Frame name="boss-lava" alt="바닥에 주황색 용암 장판이 깔린 보스방" title="용암 장판">몸체 투사체가 떨어진 자리에 생긴 용암 장판입니다(11:27).</Frame>
          </div>
          <Evidence summary="머리 궤적 기록 · 몸체 추종 · 파괴 후 재정렬 코드 보기" code={bossTrail} links={[{ label: "CBossDesert 코드 보기", href: sourceAt("Client/Code/CBossDesert.cpp") }]} />
          <Evidence summary="벽 회전 · 공격 선택 · Body Light 반사 코드 보기" code={bossAttack} links={[{ label: "CBossDesert 코드 보기", href: sourceAt("Client/Code/CBossDesert.cpp") }, { label: "CBoss3CircleBody 코드 보기", href: sourceAt("Client/Code/CBoss3CircleBody.cpp") }, { label: "CBossDesertHPBar 코드 보기", href: sourceAt("Client/Code/CBossDesertHPBar.cpp") }]} />
        </div>
      </div></section>
    </section>

    <section id="problems" className="expedition-group" aria-labelledby="moon-problems-title">
      <header className="expedition-group-banner"><div className="container expedition-group-heading"><span className="expedition-kicker">PROBLEM SOLVING / 03–04</span><h2 id="moon-problems-title">어려웠던 점</h2></div></header>

      <section id="lifetime" className="expedition-case"><div className="container expedition-case-inner">
        <ExpeditionChapterHeading number="03" label="OBJECT LIFETIME" title="오브젝트 생명주기와 DontDestroy 재사용" technology="Destroy · DontDestroySceneLoad · 참조 카운트 · PendingEvent" />
        <div className="expedition-case-content expedition-pipeline-copy">
          <p>로고 · 마을 · 던전 · 보스방은 각각 Scene이고, Scene을 바꾸면 이전 Scene의 Layer와 그 안의 오브젝트가 모두 해제됩니다. 그런데 Player와 인벤토리, HP Bar, 무기 · 코인 UI는 마을에서 던전으로 넘어가도 체력과 아이템을 그대로 이어 써야 했습니다. 반대로 화살과 보스 투사체는 맞는 순간 충돌 콜백 안에서 스스로 Destroy를 부르는데, 그때 CCollisionManager는 아직 Collider 목록을 돌고 있습니다.</p>
          <p>이 두 경우를 Client에서 직접 처리하면, 팀원마다 Scene이 바뀔 때 오브젝트를 새 Layer로 옮기고 Collider를 다시 등록하거나 콜백 안에서 지워도 되는 시점을 따로 챙겨야 합니다. 그래서 지울 때는 Destroy, 남길 때는 DontDestroySceneLoad 하나만 부르면 나머지는 Engine이 맡게 했습니다.</p>
          <h4 className="nier-subhead">Update에서 지울 오브젝트</h4>
          <p>Destroy는 삭제 표시만 하고, 해제는 Layer가 Update를 돌다 그 표시를 확인할 때 합니다. 그래서 충돌 콜백 안에서 불러도 돌고 있는 목록이 바뀌지 않고, 삭제 표시가 붙은 오브젝트는 해제 전까지 렌더 목록에 들어가지 않습니다.</p>
          <h4 className="nier-subhead">Scene 교체 때 남길 오브젝트</h4>
          <p>남길 오브젝트는 참조 카운트로 가립니다. DontDestroySceneLoad로 캐시에 넣은 오브젝트는 캐시가 참조 하나를 쥐고 있어서, Set_Scene이 이전 Scene의 Layer를 해제해도 남습니다. 이어서 Load_CacheObject가 Init_Layer로 적어 둔 Layer 이름과 키로 새 Layer에 넣고, 비워진 충돌 목록에 Rect · Sphere Collider를 다시 등록합니다.</p>
          <Flow label="DontDestroy 오브젝트가 Scene을 넘어가는 순서" steps={["DontDestroySceneLoad: 캐시가 참조 보유", "Set_Scene: 이전 Layer가 참조를 놓음", "캐시 참조가 남은 오브젝트만 생존", "Load_CacheObject: 새 Layer · 충돌 목록 등록"]} />
          <Evidence summary="오브젝트 유지 · 캐시 복원 · Collider 재등록 코드 보기" code={cacheRestore} links={[{ label: "CManagement 코드 보기", href: sourceAt("Engine/Code/CManagement.cpp") }, { label: "CGameObject.h 보기", href: sourceAt("Engine/Header/CGameObject.h") }]} />
          <h4 className="nier-subhead">Scene 교체 시점</h4>
          <p>Scene 교체는 PendingEvent에 예약해 렌더링이 끝난 뒤 실행합니다. Trigger나 버튼도 Scene 안의 오브젝트라 Update 중에 바로 바꾸면 돌고 있는 자기 Scene을 지우기 때문입니다. Fade_In이 화면을 다 덮은 프레임에 예약된 교체가 실행되고, 새 Scene에서 Fade_Out으로 다시 밝아집니다.</p>
          <Frame name="scene-fade" alt="마을 화면이 어두워진 뒤 던전 화면이 나타나는 네 장면" title="마을 → 던전 전환">왼쪽 위부터 마을, Fade_In으로 어두워지는 화면, 다 덮인 프레임, 던전 Scene에서 다시 밝아진 화면입니다(시연 영상 9:51~9:53).</Frame>
          <Evidence summary="PendingEvent · Fade 코드 보기" code={sceneTiming} links={[{ label: "CManagement 코드 보기", href: sourceAt("Engine/Code/CManagement.cpp") }, { label: "CFadeManager 코드 보기", href: sourceAt("Client/Code/CFadeManager.cpp") }]} />
        </div>
      </div></section>

      <section id="collision" className="expedition-case"><div className="container expedition-case-inner">
        <ExpeditionChapterHeading number="04" label="COLLISION" title="Collider 참조 해제와 Sphere · Rect 판정" technology="CCollisionManager · Remove_Collider · 겹침 목록 · SphereRectCollision" />
        <div className="expedition-case-content expedition-pipeline-copy">
          <h4 className="nier-subhead">Collider 참조 해제</h4>
          <p>Collider는 소유 오브젝트와 CCollisionManager, 겹쳐 있던 상대 Collider들이 함께 가리켜서, 오브젝트가 지워진 뒤 남은 주소를 건드리는 dangling이 생겼습니다. 소유는 오브젝트에만 두고 나머지는 주소만 들게 한 뒤, Collider가 해제될 때 Remove_Collider로 Manager 목록과 상대들의 겹침 목록에서 스스로 빠지게 했습니다.</p>
          <Flow label="오브젝트 삭제 순서" steps={["Destroy 표시 · 렌더 목록에서 제외", "Layer가 Update에서 해제", "Collider Free", "Manager · 겹침 목록에서 제거"]} />
          <Evidence summary="Collider 해제 · 참조 정리 코드 보기" code={colliderRemove} links={[{ label: "CCollider 코드 보기", href: sourceAt("Engine/Code/CCollider.cpp") }, { label: "CCollisionManager 코드 보기", href: sourceAt("Engine/Code/CCollisionManager.cpp") }]} />
          <h4 className="nier-subhead">Sphere · Rect 판정</h4>
          <p>Player는 Rect Collider를 쓰고, 투사체는 Rect나 Sphere hitbox 중 하나를 골라 씁니다. 탄막처럼 Sphere hitbox를 쓰는 투사체는 Player와 Sphere · Rect 판정으로 만나는데, 탄이 Player를 지나가도 맞지 않는 경우가 생겼습니다.</p>
          <p>원인은 Sphere와 Rect 사이 거리를 재는 계산이었습니다. 구 중심에서 가장 가까운 Rect 위의 점을 구해 그 거리를 반지름과 비교하는데, 이전 코드는 축마다 Rect의 최솟값과 최댓값 중 구 중심에 가까운 쪽을 골랐습니다. 구 중심이 Rect 범위 안에 있는 축에서도 끝값을 고르니 가장 가까운 점이 늘 Rect의 꼭짓점이 됐고, 탄이 Player 사각형 안에 들어와 있어도 꼭짓점까지 거리가 반지름보다 멀면 충돌로 치지 않았습니다.</p>
          <p>그래서 축마다 구 중심이 범위 밖일 때만 가까운 끝값으로 자르고, 범위 안이면 구 중심 좌표를 그대로 쓰게 바꿨습니다. 이제 탄이 사각형 안에 있으면 거리가 0이 되고, 바깥에 있으면 가장 가까운 면이나 모서리까지 거리를 재므로 탄이 Player에 닿는 프레임에 Enter가 들어갑니다.</p>
          <Evidence summary="수정 전후 판정 코드 보기" code={sphereRect} links={[{ label: "CCollisionManager 코드 보기", href: sourceAt("Engine/Code/CCollisionManager.cpp") }]} />
        </div>
      </div></section>
    </section>

    <section id="retrospective" className="expedition-group" aria-labelledby="moon-retro-title">
      <header className="expedition-group-banner"><div className="container expedition-group-heading"><span className="expedition-kicker">RETROSPECTIVE</span><h2 id="moon-retro-title">회고</h2></div></header>
      <div className="container expedition-case-inner"><div className="expedition-case-content expedition-pipeline-copy">
        <p>프레임워크를 맡으면서 가장 오래 걸린 건 오브젝트가 생기고 사라지는 규칙이었습니다. 객체를 누가 소유하고 언제 놓는지 정하지 않은 채 기능부터 붙였고, 그 탓에 삭제 처리만 세 번 고쳤습니다. 팀원들이 이미 그 API로 콘텐츠를 만들고 있어서, 고칠 때마다 Client가 쓰는 함수는 그대로 두고 Engine 안쪽만 바꿔야 했습니다.</p>
        <p>후반에 만든 사막 보스는 몸체 · WallChecker · 투사체가 전투 내내 생기고 사라지는 콘텐츠라, 해제된 Collider 주소가 상대 겹침 목록에 남던 부분도 이 작업을 하면서 Remove_CheckMember로 마저 지웠습니다.</p>
      </div></div>
    </section>

    <section id="closing" className="expedition-closing"><div className="container expedition-closing-inner"><span className="eyebrow">LINKS</span><h2>관련 자료</h2><div className="expedition-links"><IconLink href={moonLinks.source} target="_blank" rel="noopener noreferrer">GitHub ↗</IconLink><IconLink href={moonLinks.youtube} target="_blank" rel="noopener noreferrer">YouTube 시연 영상 ↗</IconLink><IconLink href={siteUrl("/#projects")}>프로젝트 목록으로 돌아가기 ↗</IconLink></div></div></section>
  </main>;
}
